import { ReactNode } from "react";

import { useUserConsentGuard } from "@/guards/user-consent-guard/use-user-consent-guard";
import { UserConsentGuardDialog } from "@/guards/user-consent-guard/user-consent-guard-dialog";

interface Props {
    children: ReactNode;
}

export const UserConsentGuard = ({ children }: Props) => {
    const { isConsentExpired, acceptConsent, isAcceptConsentLoading } = useUserConsentGuard();

    if (isConsentExpired) {
        return (
            <UserConsentGuardDialog onAcceptConsent={acceptConsent} isAcceptConsentLoading={isAcceptConsentLoading} />
        );
    }

    return <>{children}</>;
};
